// extracted by mini-css-extract-plugin
module.exports = {"testCardContainer":"PaperCard_testCardContainer__1eduX","disabledBtn":"PaperCard_disabledBtn__2rEaH"};